import type { TestLineOption } from '@util/testCatalogue'
import * as yup from 'yup'

const labTestOptionSchema = yup.object({
  label: yup.string().required(),
  value: yup
    .mixed<number | string>()
    .required()
    .test('lab-test-value', 'Invalid test', val =>
      typeof val === 'number' ? Number.isInteger(val) && val > 0 : typeof val === 'string' && val.trim().length > 0
    ),
  source: yup.mixed<'facility' | 'catalogue' | 'free_text'>().oneOf(['facility', 'catalogue', 'free_text']).optional(),
  priced: yup.boolean().optional(),
  performed_at: yup.mixed<'our_lab' | 'outside'>().oneOf(['our_lab', 'outside']).optional()
})

/** Doctor encounter — order lab modal (maps to `lab_order` JSON:API create body). */
export const labOrderFormSchema = yup.object({
  lab_tests: yup
    .array()
    .of(labTestOptionSchema)
    .min(1, 'Select at least one test')
    .required('Select at least one test'),
  note: yup.string().trim().default('')
})

export type LabOrderFormValues = {
  lab_tests: TestLineOption[]
  note: string
}
